import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';

export interface UnionInitialValues {
  isPreRegistration: boolean;
  hasCadastroData: boolean;
  loadedPrevRegistration: boolean;
  isNonResident: boolean;
  mode: {new: boolean; edit: boolean; detail: boolean};
  isSupplyCommencementEditable: boolean;
  preFilledForm: object | undefined;
}

export const INITIAL_VALUES = new InjectionToken<UnionInitialValues>('initial.values');

export const FIXED_VALUES_OBS = new InjectionToken<Observable<UnionInitialValues | undefined>>('FIXED_VALUES_OBS');

export const ROUTER_BASE_PATH = new InjectionToken<string>('ROUTER_BASE_PATH');
